---
description: Explore a vague modeling request into a concrete direction before planning.
---

1. Ask what the part must do: purpose, sizes, fits. Use question when sizes or intent are ambiguous rather than guessing.
2. Gather context: glob the project files, read the entry file, grep for related shapes, docs for API options, websearch for real-world reference values.
3. Propose two or three approaches with tradeoffs: shape choices, parameters, complexity.
4. Converge on one direction with named dimensions and a first verification step (measure or check).
5. Stop at a decision. Do not write code or a full plan here.
